// Cookie consent state (same pattern as the Siamais build). Nothing that sets
// marketing or analytics cookies loads until the visitor accepts.
const KEY = "lw_consent";

export function hasConsent() {
  try { return localStorage.getItem(KEY) === "granted"; } catch { return false; }
}

export function consentAnswered() {
  try { return !!localStorage.getItem(KEY); } catch { return true; }
}

export function setConsent(granted) {
  try { localStorage.setItem(KEY, granted ? "granted" : "denied"); } catch {}
  window.dispatchEvent(new CustomEvent("lw:consent", { detail: { granted } }));
}
